import style from "../style/info.module.css";

export default function Info() {
  return (
    <main className={style.container}>
      <header className={style.header}>
        <h1 className={style.title}>Informações prestadas pelo OrgFin</h1>
      </header>

      <section className={style.card}>
        <h2 className={style.title}> O que significa OrgFin?</h2>

        <p className={style.paragraph}>
          OrgFin significa Organização Financeira. O sistema foi criado para
          ajudar o usuário a visualizar seus gastos, receitas e estimar seu
          saldo disponível antes de tomar decisões financeiras.
        </p>
        <h2 className={style.title}>O que é Saldo Projetado?</h2>

        <p className={style.paragraph}>
          O saldo projetado representa uma estimativa do dinheiro que poderá
          permanecer disponível após considerar ganhos (receitas) e gastos cadastrados.
        </p>

        <div className={style.tip}>
          <strong>Vantagem</strong>

          <p className={style.paragraph}>Permite que usuário visualize diferentes cenários antes de realizar um gasto.</p>
        </div>
      </section>

      <section className={style.card}>
        <h2 className={style.title}>Gasto x Investimento</h2>

        <p className={style.paragraph}>
          Gasto é toda saída de dinheiro destinada à compra de produtos,
          serviços ou pagamento de contas.
        </p>

        <p className={style.paragraph}>
          Investimento é a aplicação de dinheiro visando retorno financeiro
          futuro.
        </p>

        <div className={style.example}>
          <h3 className={style.title}>Exemplos de gastos desnecessários</h3>

          <ul>
            <li>Comprar outro celular sem necessidade.</li>
            <li>Trocar de televisão apenas porque lançou um modelo novo.</li>
            <li>Comprar roupas apenas por impulso.</li>
          </ul>
        </div>
      </section>

      <section className={style.card}>
        <h2>Reserva de Emergência</h2>

        <p className={style.paragraph}>
          É um valor separado exclusivamente para lidar com situações
          inesperadas, como perda de renda ou despesas médicas.
        </p>

        <div className={style.tip}>
          <strong>Como calcular?</strong>

          <ol>
            <li>Cadastre seus gastos essenciais e seus ganhos (receita).</li>
            <li>Acesse "Juntar Quanto".</li>
            <li>Informe quantos meses deseja reservar.</li>
            <li>O OrgFin fará o cálculo automaticamente.</li>
          </ol>
        </div>
      </section>
    </main>
  );
}
